import apiV2 from "api-v2";
import {
  BulkAction,
  CheckDuplicatesResult,
  RfxDocumentRow,
  UpdateRfxDocumentData,
} from "../types/rfx-document.types";

/*
 * Parallel API client for the RFx Template document manager. Mirrors the
 * RFx (`rfx-document-api.ts`) surface 1:1 so the hooks can switch backends by
 * URL alone without caring about response shape — the BE returns the same
 * RfxDocumentResource for both contexts.
 */

interface ApiListResponse<T> {
  data: T[];
}

interface ApiSingleResponse<T> {
  data: T;
}

export const fetchTemplateDocuments = async (
  templateId: number
): Promise<RfxDocumentRow[]> => {
  const response = await apiV2.get<ApiListResponse<RfxDocumentRow>>(
    `template/${templateId}/documents`
  );
  return response.data.data;
};

export const updateTemplateDocument = async (
  templateId: number,
  docId: number,
  data: UpdateRfxDocumentData
): Promise<RfxDocumentRow> => {
  const response = await apiV2.patch<ApiSingleResponse<RfxDocumentRow>>(
    `template/${templateId}/document/${docId}/update`,
    data
  );
  return response.data.data;
};

export const reorderTemplateDocuments = async (
  templateId: number,
  orderedIds: number[]
): Promise<void> => {
  await apiV2.post(`template/${templateId}/documents/reorder`, {
    ordered_ids: orderedIds,
  });
};

export const bulkTemplateAction = async (
  templateId: number,
  action: BulkAction,
  docIds: number[],
  categoryId?: number
): Promise<void> => {
  await apiV2.post(`template/${templateId}/documents/bulk-action`, {
    action,
    document_ids: docIds,
    ...(categoryId !== undefined ? { category_id: categoryId } : {}),
  });
};

export const checkTemplateDuplicates = async (
  templateId: number,
  fileNames: string[]
): Promise<CheckDuplicatesResult> => {
  const response = await apiV2.post<ApiSingleResponse<CheckDuplicatesResult>>(
    `template/${templateId}/documents/check-duplicates`,
    { file_names: fileNames }
  );
  return response.data.data;
};
